import {
  EventDetailType,
  EventsIndexType,
  VirtualEventsIndexType,
} from '../types/index';
import {axiosClient} from '../axios';

import {
  convertFiltersToSearchString,
  MaybePaginatedGetter,
  FiltersOf,
  getPaginatedFiltersMapping,
  getViewKeyHeader,
  ViewKeyOptions,
} from '../utils/index';

const eventsFiltersMapping = getPaginatedFiltersMapping({
  eventType: 'event_types__contains',
  virtual: 'virtual',
  startYear: 'starts_at__year',
  startMonth: 'starts_at__month',
  upcoming: 'upcoming',
  excludeSlug: 'slug__ne',
  order: 'ordering',
});

export const getEvents: MaybePaginatedGetter<
  EventDetailType,
  FiltersOf<typeof eventsFiltersMapping>
> = async (
  filters: FiltersOf<typeof eventsFiltersMapping>,
  options: ViewKeyOptions,
) => {
  const {data} = await axiosClient.get(
    `/events/${convertFiltersToSearchString(filters, eventsFiltersMapping)}`,
    {headers: getViewKeyHeader(options?.viewKey)},
  );
  return data;
};

export const getEventBySlug = async (
  slug: string,
  viewKey?: string,
): Promise<EventDetailType> => {
  const {data} = await axiosClient.get<EventDetailType>(`/events/${slug}/`, {
    headers: getViewKeyHeader(viewKey),
  });
  return data;
};

export const getEventsIndex = async (
  viewKey?: string,
): Promise<EventsIndexType> => {
  const {data} = await axiosClient.get<EventsIndexType>('/events-index/', {
    headers: getViewKeyHeader(viewKey),
  });
  return data;
};

export const getVirtualEventsIndex = async (
  viewKey?: string,
): Promise<VirtualEventsIndexType> => {
  const {data} = await axiosClient.get<VirtualEventsIndexType>(
    '/virtual-events-index/',
    {headers: getViewKeyHeader(viewKey)},
  );
  return data;
};
